module.exports = __webpack_public_path__ + "./images/cabc258d4c25b5243955eba64b31208e.webp";